import { ConcreteMeasure } from "./Measure";
import { MeasureType } from "./MeasureType";

export class AreaMeasure extends ConcreteMeasure {
    constructor() {
        super();
        this.type = MeasureType.AREA;
    }
}